<template>
	<AppIconButton :type="dynamicIcon" @click="toggleGridView" />
</template>

<script lang="ts" setup>
import AppIconButton from "@/components/AppIconButton.vue";
import SoundService from "@/game/SoundService";
import useSettingsStore from "@/store/useSettingsStore";
import { IconTypes } from "@/types/ui";
import { storeToRefs } from "pinia";
import { computed, markRaw } from "vue";

const soundService = markRaw(SoundService.getInstance());

const settingsStore = useSettingsStore();
const { tileDetailGridView } = storeToRefs(settingsStore);

const toggleGridView = (): void => {
	soundService.playGenerickClick();
	settingsStore.setTileDetailGridView(!tileDetailGridView.value);
};

const dynamicIcon = computed((): IconTypes => {
	return tileDetailGridView.value ? IconTypes.LIST : IconTypes.GRID;
});
</script>
